import {EntityService} from '../../../service/EntityService';

export class NotificationService extends EntityService {

  static entity = 'app/notification';

}
